// src/App.tsx
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ConfigProvider } from "antd";
import MainLayout from "./components/MainLayout";
import Vocabulary from "./pages/Vocabulary";
import Conversation from "./pages/Conversation";
import "./App.css";

const App: React.FC = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          // Thay đổi ở đây
          fontFamily: "'Kanit', sans-serif",
          colorPrimary: "#FF7E67",
          colorLink: "#FF7E67",
          borderRadius: 16,
          colorBgLayout: "#fcf9f4",
          fontSize: 16, // Kanit hiển thị hơi nhỏ hơn một chút, tăng base size lên 16px sẽ dễ đọc hơn
        },
        components: {
          Button: {
            fontWeight: 500, // Kanit Regular (400) hơi mỏng, dùng 500 cho Button sẽ đẹp hơn
            controlHeight: 45, // Tăng chiều cao nút bấm một chút cho thoáng
            contentFontSize: 16,
          },
          Layout: {
            headerBg: "#ffffff",
          },
          Menu: {
            fontSize: 16,
          },
          Table: {
            headerBg: "#fff0eb",
          },
        },
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Vocabulary />} />
            <Route path="hoi-thoai" element={<Conversation />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
};

export default App;
